<template>
    <div class="list-image">
      <el-row :gutter="20" >
        <el-col :span="6"  v-for="(item,index) in list" :key="index" class="item">
            <div class="border">
                <div class="img" :style="'background-image:url('+(item.first_img==''?'static/img/nopic.gif':item.first_img)+')'">
                </div>
            </div>
            <div class="title">
                <el-tag v-if="item.port_new=='1'" size="mini">新</el-tag>
                <el-tag  v-if="item.port_top=='1'" size="mini" type="danger">顶</el-tag>
                <router-link :to="'/article/'+item.article_id" target="_blank">{{item.title}}</router-link>
            </div>
            <div class="date">{{item.publish_time.substring(0,10)}}</div>
        </el-col>
    </el-row>
     <div class="no-data" v-if="!list.length">暂无文章</div>
  </div>
</template>

<script>
export default {
    props:['list']

}
</script>

<style lang='scss'>
.list-image{
    margin: 20px 0;
    .item{
        margin-bottom: 20px;
        .img{
        padding-bottom: 80%;
        }
        .border{
            padding: 0;
            transition: .3s;
        }
        .title{
            height: 44px;
            overflow: hidden;
            margin: 10px 0 16px 0;
            line-height: 1.4;
            font-size: 16px;
            font-weight: bold;
            color: #5a5a55;
            &:hover{
                color: $primary;
            }
        }
        .date{
            color: #b4b0aa;
            font-size: 12px;
        }

    }
    
}
</style>
